import { useState } from 'react';
import { toValue } from '../listbox/index.js';
/**
 * useDropdownState
 */
export const useDropdownState = (defaultSelected = '') => {
    const [expanded, setExpanded] = useState(false);
    const [selected, setSelected] = useState(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : '');
    const multiple = Array.isArray(selected);
    const onOptionSelect = (option) => {
        // If selected is an array, add/remove option
        // Otherwise, just set the value
        setSelected((prevSelected) => {
            const value = toValue(option) || '';
            // Multiple case
            if (Array.isArray(prevSelected)) {
                return prevSelected.find((opt) => toValue(opt) === value)
                    ? prevSelected.filter((opt) => toValue(opt) !== value)
                    : [...prevSelected, option];
            }
            else {
                // Single case (ternary allows users to remove a selection if desired)
                return value === prevSelected ? '' : option;
            }
        });
    };
    const onClear = () => {
        setSelected(multiple ? [] : '');
    };
    const toggleExpanded = () => setExpanded((prevState) => !prevState);
    return {
        expanded,
        multiple,
        onClear,
        onOptionSelect,
        selected,
        setExpanded,
        toggleExpanded,
    };
};
